import { gql, useLazyQuery, useQuery } from '@apollo/client'
import { Select, SelectProps, Typography } from 'antd'
import { debounce } from 'lodash'
import React from 'react'
import { SOCIETE_DETAIL_BY_ID } from '../../apollo/query/societe.query'
import { D4_Societe } from '../../types'

const SOCIETE = gql`
  query SocietesByRaisonsociale($search: String!) {
    societes: d4_societe(where: { raisonsociale: { _ilike: $search } }) {
      id
      raisonsociale
      mail1
      mail2
      dtype
    }
  }
`

const { Option } = Select

const D4SelectSociete: React.FC<{ societeId?: number[] } & SelectProps<any>> = ({ societeId, ...props }) => {
  const [search, { data }] = useLazyQuery<{ societes: D4_Societe[] }, { search: string }>(SOCIETE)
  const { data: societeOne } = useQuery(SOCIETE_DETAIL_BY_ID, { variables: { ids: societeId }, skip: !societeId })

  const handleSearch = debounce((text: string) => {
    search({
      variables: {
        search: '%' + text + '%',
      },
    })
  }, 300)

  const societes: D4_Societe[] = [...(data?.societes ?? []), ...(societeOne?.societes ?? [])]

  return (
    <Select onSearch={handleSearch} optionFilterProp="label" showArrow showSearch {...props}>
      {societes.map((societe) => (
        <Option key={societe.id} value={societe.id} label={societe.raisonsociale}>
          <Typography.Text strong>{societe.raisonsociale}</Typography.Text>
          <br />
          <Typography.Text italic>{societe.mail1}</Typography.Text>
        </Option>
      ))}
    </Select>
  )
}

export default D4SelectSociete
